import type { ComponentPropsWithRef, ReactNode } from 'react';
import type { VariantProps } from 'tailwind-variants';
import { buttonStyles } from './button-styles';

export type ButtonProps = ComponentPropsWithRef<'button'> &
  VariantProps<typeof buttonStyles> & {
    leadingIcon?: ReactNode;
  };

export function Button({
  variant,
  size,
  iconOnly,
  leadingIcon,
  className,
  children,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button type={type} className={buttonStyles({ variant, size, iconOnly, className })} {...props}>
      {leadingIcon}
      {children}
    </button>
  );
}

export type IconButtonProps = Omit<ButtonProps, 'iconOnly' | 'leadingIcon' | 'aria-label'> & {
  /** Required: icon-only buttons need an accessible name. */
  label: string;
};

export function IconButton({ label, variant = 'ghost', ...props }: IconButtonProps) {
  return <Button aria-label={label} variant={variant} iconOnly {...props} />;
}
